import { cn } from "@/lib/utils";

export const Switch = ({
    className,
    disabled,
    checked,
    onChange,
    ...props
}: {
    className?: string;
    disabled?: boolean;
    checked: boolean;
    onChange: (value: boolean) => void;
}) => {
    return (
        <div
            className={cn(
                `h-6 w-11 cursor-pointer rounded-[32px] p-1 transition-all
                duration-300`,
                checked ? "bg-[#3060be]" : "bg-text-placeholder",
                disabled && "cursor-not-allowed bg-text-placeholder opacity-50",
                className
            )}
            onClick={() => {
                if (!disabled) {
                    onChange(!checked);
                }
            }}
            {...props}
        >
            <div
                className={cn(
                    `h-4 w-4 rounded-full bg-common-white-main transition-all
                    duration-300`,
                    checked ? "translate-x-[calc(44px-24px)]" : "translate-x-0"
                )}
            />
        </div>
    );
};
